module.exports = __webpack_public_path__ + "assets/img/蘑菇小兵364 283px.d178d8df.jpg";